var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticClass: "mt-1" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                { attrs: { outlined: "", elevation: "1" } },
                [
                  _vm.showTitleBar
                    ? _c(
                        "v-toolbar",
                        { attrs: { dark: "", color: "primary" } },
                        [
                          _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
                          _vm._v(" "),
                          _c("v-spacer"),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-row", { staticClass: "mt-4" }),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "d-inline d-sm-inline d-md-none d-lg-none d-xl-none secondary--text text-bold",
                          attrs: { cols: "12", align: "center" },
                        },
                        [
                          _vm.stripeEstimates
                            ? _c(
                                "v-card",
                                {
                                  staticClass: "mt-n7",
                                  attrs: { flat: "", color: "secondary" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass:
                                        "white--text text-bold text-h6",
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            align: "center",
                                          },
                                        },
                                        [
                                          _c("span", {}, [
                                            _vm._v(_vm._s(_vm.totalText)),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass:
                                        "white--text text-bold text-h6 mt-n6",
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            align: "center",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getTotalRecurringEstimate
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6", lg: "6", xl: "6" } },
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "" } },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass:
                                    "ml-2 d-inline d-sm-inline d-md-none d-lg-none d-xl-none",
                                },
                                [
                                  _c(
                                    "v-col",
                                    [
                                      !_vm.hasAnnaulPriceOnly
                                        ? _c("v-select", {
                                            attrs: {
                                              label: "Billing period",
                                              items: _vm.billingCycles,
                                              disabled:
                                                _vm.pleaseWait ||
                                                _vm.cantChange,
                                              outlined: "",
                                              dense: "",
                                            },
                                            model: {
                                              value: _vm.billingCycle,
                                              callback: function ($$v) {
                                                _vm.billingCycle = $$v
                                              },
                                              expression: "billingCycle",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "1" } }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                { staticClass: "ml-2" },
                                [
                                  _c("v-col", { attrs: { cols: "6" } }, [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v("Add plans")]
                                    ),
                                    _vm._v(" "),
                                    _vm.availablePlans.length > 0 &&
                                    !_vm.hasSiverPlan
                                      ? _c(
                                          "span",
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "mx-2",
                                                attrs: {
                                                  depressed: "",
                                                  fab: "",
                                                  "x-small": "",
                                                  color: "primary",
                                                  disabled:
                                                    _vm.pleaseWait ||
                                                    _vm.cantChange,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.plansDialog = true
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { dark: "" } },
                                                  [
                                                    _vm._v(
                                                      "\n                          mdi-plus\n                        "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "5" } },
                                    [
                                      !_vm.hasAnnaulPriceOnly
                                        ? _c("v-select", {
                                            attrs: {
                                              label: "Billing period",
                                              items: _vm.billingCycles,
                                              disabled:
                                                _vm.pleaseWait ||
                                                _vm.cantChange,
                                              outlined: "",
                                              dense: "",
                                            },
                                            model: {
                                              value: _vm.billingCycle,
                                              callback: function ($$v) {
                                                _vm.billingCycle = $$v
                                              },
                                              expression: "billingCycle",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "1" } }),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "1" } }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                { staticClass: "ml-2 mt-n4" },
                                [
                                  _c("v-col", { attrs: { cols: "11" } }, [
                                    _c(
                                      "div",
                                      [
                                        _c("product-item", {
                                          attrs: {
                                            invoiceItems: _vm.invoiceItems,
                                            isLoading: _vm.pleaseWait,
                                            readOnly: _vm.cantChange,
                                          },
                                          on: {
                                            planRemoved: _vm.invoiceListUpdated,
                                            quantityChange:
                                              _vm.invoiceItemQuantityChange,
                                            toLearner: _vm.toLearner,
                                            planRestored:
                                              _vm.invoiceListItemRetored,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "1" } }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                { staticClass: "ml-2" },
                                [
                                  _c(
                                    "v-col",
                                    [
                                      _c("span", [
                                        _c("small", [
                                          _vm._v("Add promotion code"),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      !_vm.showCouponControls
                                        ? _c(
                                            "v-icon",
                                            {
                                              attrs: { small: "" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.showCouponControls = true
                                                },
                                              },
                                            },
                                            [_vm._v("mdi-chevron-down")]
                                          )
                                        : _c(
                                            "v-icon",
                                            {
                                              attrs: { small: "" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.showCouponControls = false
                                                },
                                              },
                                            },
                                            [_vm._v("mdi-chevron-up")]
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.showCouponControls
                                ? _c(
                                    "v-row",
                                    { staticClass: "ml-6" },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "10" } },
                                        [
                                          _c("v-text-field", {
                                            ref: "couponRef",
                                            attrs: {
                                              transition: "scale-transition",
                                              label: "Enter code",
                                              "append-icon": "mdi-arrow-right",
                                              rules: [_vm.isValidCoupon],
                                              outlined: "",
                                              disabled: _vm.pleaseWait,
                                              dense: "",
                                            },
                                            on: {
                                              "click:append": function (
                                                $event
                                              ) {
                                                return _vm.applyCoupon()
                                              },
                                            },
                                            nativeOn: {
                                              keyup: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                return _vm.applyCoupon()
                                              },
                                            },
                                            model: {
                                              value: _vm.coupon,
                                              callback: function ($$v) {
                                                _vm.coupon = $$v
                                              },
                                              expression: "coupon",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-col", { attrs: { cols: "2" } }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showCouponControls &&
                              _vm.couponDescription &&
                              !this.couponError
                                ? _c(
                                    "v-row",
                                    { staticClass: "mt-n12 ml-7" },
                                    [
                                      _c("v-col", { attrs: { cols: "8" } }, [
                                        _c("span", [
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(_vm.couponDescription)
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                { staticClass: "ml-2" },
                                [
                                  _c("v-col", [
                                    _c("span", [_vm._v("Card information")]),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isValidAuthorCount
                                ? _c(
                                    "v-row",
                                    { staticClass: "ml-2 mr-n1 mt-n4" },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "11" } },
                                        [
                                          !_vm.initialLoad && !_vm.cardOnFile
                                            ? _c(
                                                "v-card",
                                                {
                                                  style: _vm.cardFocus
                                                    ? "height: 40px; border: 2px solid black;"
                                                    : "height: 40px;border: 1px solid #ACA8A3;",
                                                  attrs: {
                                                    outlined: "",
                                                    flat: "",
                                                  },
                                                },
                                                [
                                                  _c("StripeElements", {
                                                    ref: "elms",
                                                    staticClass: "pt-1 ml-2",
                                                    attrs: {
                                                      "stripe-key":
                                                        _vm.stripeKey,
                                                      "instance-options":
                                                        _vm.stripeOptions,
                                                      "elements-options":
                                                        _vm.elementsOptions,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function ({
                                                            elements,
                                                          }) {
                                                            return [
                                                              _c(
                                                                "StripeElement",
                                                                {
                                                                  ref: "card",
                                                                  attrs: {
                                                                    type: "card",
                                                                    elements:
                                                                      elements,
                                                                    options:
                                                                      _vm.cardOptions,
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      _vm.changeCardInput,
                                                                    focus:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.cardFocus = true
                                                                      },
                                                                    blur: function (
                                                                      $event
                                                                    ) {
                                                                      _vm.cardFocus = false
                                                                    },
                                                                  },
                                                                }
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      1988493747
                                                    ),
                                                  }),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-start caption",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    The card ending in "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.last4Digits ||
                                                          "----"
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " will be used for all transactions\n                    "
                                                  ),
                                                  _c("div", [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: { href: "#" },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            _vm.changePaymentMethod = true
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("Add a new card")]
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "error--text mt-2" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(_vm.cardError) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-inline d-sm-inline d-md-none d-lg-none d-xl-none",
                                },
                                [
                                  _c(
                                    "v-row",
                                    { staticClass: "ml-2 mr-4 mt-n4" },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "mt-n5",
                                          attrs: { cols: "1" },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            model: {
                                              value: _vm.eulaSelected,
                                              callback: function ($$v) {
                                                _vm.eulaSelected = $$v
                                              },
                                              expression: "eulaSelected",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-col", [
                                        _c(
                                          "span",
                                          { staticClass: "disclaimer-text" },
                                          [
                                            _c("small", [
                                              _vm._v(
                                                "By checking this box, I confirm to have read, fully understood, accept, and agree to be bound by the terms and conditions of the "
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "https://www.elblearning.com/terms",
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "ELB Learning Subscription and License Agreement."
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    [
                                      _c("v-col", { attrs: { cols: "1" } }),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "10",
                                            align: "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "entity-button-text",
                                              attrs: {
                                                block: "",
                                                color: "secondary",
                                                disabled:
                                                  _vm.pleaseWait ||
                                                  _vm.noCardInfo ||
                                                  !_vm.isValidAuthorCount ||
                                                  !_vm.eulaSelected,
                                              },
                                              on: {
                                                click: _vm.completeCheckout,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(_vm.checkoutBtn) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-col", { attrs: { cols: "1" } }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "d-none d-sm-none d-md-inline d-lg-inline d-xl-inline",
                          attrs: { cols: "6" },
                        },
                        [
                          _vm.stripeEstimates && _vm.isValidAuthorCount
                            ? _c(
                                "v-card",
                                {
                                  staticClass: "ml-n8",
                                  attrs: { outlined: "", elevation: "2" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    { staticClass: "ml-2" },
                                    [
                                      _c("v-col", [
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-bold" },
                                          [_vm._v("Summary")]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _vm.showCouponLineItem
                                    ? _c(
                                        "v-row",
                                        { staticClass: "ml-2 mr-n2" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "8" } },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "text-bold" },
                                                [_vm._v("Discount")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                cols: "4",
                                                align: "end",
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.discountAmount))]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    { staticClass: "ml-2 mr-n2" },
                                    [
                                      _c("v-col", { attrs: { cols: "8" } }, [
                                        _c(
                                          "span",
                                          { staticClass: "text-bold" },
                                          [_vm._v("Total before tax")]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "4", align: "end" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getTotalImmediateEstimate
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    { staticClass: "ml-2 mr-n2" },
                                    [
                                      _c("v-col", { attrs: { cols: "8" } }, [
                                        _c("span", [
                                          _c("small", [
                                            _vm._v(
                                              "(" + _vm._s(_vm.getTaxInfo) + ")"
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "4", align: "end" } },
                                        [_vm._v(_vm._s(_vm.taxAmount))]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "secondary--text text-h5 text-bold",
                                        },
                                        [_vm._v(_vm._s(_vm.totalText))]
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "secondary--text text-h5 text-bold text-no-wrap",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getTotalRecurringEstimate
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "v-card",
                                {
                                  staticClass: "ml-n8",
                                  attrs: { outlined: "", elevation: "2" },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { attrs: { color: "grey lighten-4" } },
                                    [
                                      _c("v-skeleton-loader", {
                                        staticClass: "mx-auto",
                                        attrs: {
                                          "min-height": "350",
                                          type: "card-heading, divider, list-item, list-item, list-item, list-item, divider, list-item",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            { staticClass: "ml-n10 mr-4" },
                            [
                              _c(
                                "v-col",
                                { staticClass: "mt-n5", attrs: { cols: "1" } },
                                [
                                  _c("v-checkbox", {
                                    model: {
                                      value: _vm.eulaSelected,
                                      callback: function ($$v) {
                                        _vm.eulaSelected = $$v
                                      },
                                      expression: "eulaSelected",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-col", { staticClass: "ml-n2" }, [
                                _c("span", { staticClass: "disclaimer-text" }, [
                                  _c("small", [
                                    _vm._v(
                                      "By checking this box, I confirm to have read, fully understood, accept, and agree to be bound by the terms and conditions of the "
                                    ),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "https://www.elblearning.com/terms",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "ELB Learning Subscription and License Agreement."
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            { staticClass: "mt-10" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ml-n8",
                                  attrs: { align: "end" },
                                },
                                [
                                  _vm.showCancel
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "entity-button-text",
                                          attrs: {
                                            outlined: "",
                                            color: "secondary",
                                            disabled: _vm.pleaseWait,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.previousState()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Cancel\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "entity-button-text",
                                      attrs: {
                                        color: "secondary",
                                        disabled:
                                          _vm.pleaseWait ||
                                          _vm.noCardInfo ||
                                          !_vm.isValidAuthorCount ||
                                          !_vm.eulaSelected,
                                      },
                                      on: { click: _vm.completeCheckout },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.checkoutBtn) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-progress-linear", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.pleaseWait,
                        expression: "pleaseWait",
                      },
                    ],
                    staticClass: "ma-0",
                    staticStyle: {
                      height: "3px",
                      position: "absolute",
                      bottom: "0",
                    },
                    attrs: { indeterminate: true },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.plansDialog
        ? _c(
            "v-dialog",
            {
              attrs: { scrollable: "", "max-width": "580px" },
              model: {
                value: _vm.plansDialog,
                callback: function ($$v) {
                  _vm.plansDialog = $$v
                },
                expression: "plansDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dense: "" } },
                    [
                      _c("v-toolbar-title", [_vm._v("Select plans to add")]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              _vm.plansDialog = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticStyle: { height: "300px" } },
                    [
                      _c("v-simple-table", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function () {
                                return [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", { staticClass: "text-left" }, [
                                        _vm._v(
                                          "\n                  Plan\n                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text-left" }, [
                                        _vm._v(
                                          "\n                  Unit price\n                "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.availablePlans,
                                      function (plan, i) {
                                        return _c("tr", { key: i }, [
                                          _c(
                                            "td",
                                            [
                                              _c("v-checkbox", {
                                                staticClass: "mt-2",
                                                attrs: {
                                                  dense: "",
                                                  label: plan.productName,
                                                  value: plan,
                                                  disabled: plan.disabled,
                                                },
                                                model: {
                                                  value: _vm.selectedPlans,
                                                  callback: function ($$v) {
                                                    _vm.selectedPlans = $$v
                                                  },
                                                  expression: "selectedPlans",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatPrice(plan.unitPrice)
                                              ) +
                                                "/" +
                                                _vm._s(plan.interval)
                                            ),
                                          ]),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1384071803
                        ),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "entity-button-text",
                          attrs: {
                            color: "secondary",
                            block: "",
                            disabled: _vm.selectedPlans.length == 0,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.addPlans()
                            },
                          },
                        },
                        [_vm._v("\n          Add\n        ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }